import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button, Flex, Text, Spinner } from "@chakra-ui/react";
import {
  getInventoryHistoryList,
  getInventoryHistoryFilteredData,
} from "./services/inventoryHistoryServices";
import BreadCrumb from "components/ui/breadcrumb/BreadCrumb";
import ExportModal from "components/ui/modal/ExportModal";
import InventoryHistoryTable from "./components/InventoryHistoryTable";
import CryptoJS from 'crypto-js';
import NotAuthorizedCompo from "components/ui/NotAuthorizedCompo/NotAuthorizedCompo";
import { checkIdExists } from "utils/cheackAuth";
import useDecryptedPrivilege from "hooks/useDecryptedPrivilege ";


export default function InventoryHistory() {

  const retrievedArray =useDecryptedPrivilege()
  const Auth = checkIdExists(retrievedArray, 67);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [exportModal, setExportModal] = useState(false);

  const { data, isLoading, filteredData } = useSelector(
    (state) => state.reportsInventoryHistory
  );

  useEffect(() => {
    // Dispatch getInventoryHistoryList action first
    dispatch(getInventoryHistoryList())
      .then(() => {
        // Once getInventoryHistoryFilteredData is completed, dispatch getPurchasingFilteredData
        dispatch(getInventoryHistoryFilteredData());
      })
      .catch((error) => {
        throw Error("Error inventory history report data:", error);
      });
  }, [dispatch]);

  
if(Auth===false ){
  return(
    <NotAuthorizedCompo/>
  )
}

  return (
    <>
      <BreadCrumb>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          flexWrap="wrap"
        >
          <Text fontSize="1.2rem" color="dark" textTransform="capitalize">
            {t("pages.reports.inventory_reports.inventory_history")}
          </Text>

          <Flex gap={2} flexWrap="wrap">
            <Button
              type="button"
              bg="none"
              border="1px solid"
              borderColor="border"
              textTransform="capitalize"
              fontSize="1rem"
              color="text"
              _hover={{ bg: "primary", color: "light" }}
              onClick={() => setExportModal(true)}
            >
              <Text>{t("general.export")}</Text>
            </Button>
          </Flex>
        </Flex>
      </BreadCrumb>

      <>
        {isLoading ? (
          <Flex bg="light" p={4} justifyContent="center">
            <Spinner />
          </Flex>
        ) : (
          <InventoryHistoryTable data={data} filteredData={filteredData} />
        )}
      </>

      {exportModal && (
        <ExportModal
          onClose={() => setExportModal(false)}
          data={data}
          fileName={"reportsInventoryHistory"}
        ></ExportModal>
      )}
    </>
  );
}
